import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit, inject, input } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener, MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs';

export type FileFolderNode = {
    id: string;
    name: string;
    children?: FileFolderNode[];
    level?: number;
    path?: string;
};

type FlatNode = {
    id: string;
    expandable: boolean;
    name: string;
    level: number;
    path: string | undefined;
};

@Component({
    selector: 'r1-compass-lib-file-tree',
    imports: [MatTreeModule, MatButtonModule, MatIconModule, CommonModule],
    templateUrl: './file-tree.component.html',
    styleUrl: './file-tree.component.scss',
})
export class FileTreeComponent implements OnInit {
    readonly #router = inject(Router);
    readonly #route = inject(ActivatedRoute);

    readonly data = input.required<FileFolderNode[]>();

    private _transformer = (node: FileFolderNode, level: number) => {
        return {
            id: node.id,
            expandable: !!node.children && node.children.length > 0,
            name: node.name,
            level: level,
            path: node?.path ? node.path : undefined,
        };
    };

    treeControl = new FlatTreeControl<FlatNode>(
        node => node.level,
        node => node.expandable
    );

    treeFlattener = new MatTreeFlattener(
        this._transformer,
        node => node.level,
        node => node.expandable,
        node => node.children
    );

    dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    hasChild = (_: number, node: FlatNode) => node.expandable;

    activeListItem$ = this.#route.queryParams.pipe(map(params => Number(params['folderId'])));

    ngOnInit() {
        const data = this.data();
        if (data) {
            this.dataSource.data = data;
        }
    }

    navigateToTreeNode(inputNode: FlatNode, event: Event) {
        if (event instanceof KeyboardEvent) {
            if (event.key !== 'Enter') {
                return;
            }
        }
        this.#router.navigate([], { relativeTo: this.#route, queryParams: { folderId: inputNode.id } });
    }
}
